import { render, staticRenderFns } from "./ArticleSerialNumberForm.vue?vue&type=template&id=06bf09c2&scoped=true&"
import script from "./ArticleSerialNumberForm.vue?vue&type=script&lang=js&"
export * from "./ArticleSerialNumberForm.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSerialNumberForm.vue?vue&type=style&index=0&id=06bf09c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf09c2",
  null
  
)

export default component.exports